var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('span',{staticClass:"pb-lock"},[_c('i',{staticClass:"mdi mdi-lock-outline",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"pb-sr-only"},[_vm._v("Available on ")]),_vm._v(_vm._s(_vm.label))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }